// Schemas
import { schema } from 'normalizr';

export const feature = new schema.Entity('features');

export const bigClubSetting = new schema.Entity('bigClubSettings');
